import { IonButton, IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PRIVACY_LINK, TERMS_LINK } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';

import { PageStyles } from './SecurityScreen.styles';

export const SecurityScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="dark-solid">
      <OnboardingNavigation />

      <OwnAiTitle>
        We prioritize and protect your personal information
      </OwnAiTitle>

      <IonContent scrollY={false}>
        <div className="description">
          <OwnAiTitle>What happens inside, stays inside</OwnAiTitle>
        </div>

        <Player
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/lock-animation-dark.json"
          autoplay
          loop={false}
          keepLastFrame
          className="animation"
        />

        <UiTypography className="disclaimer" variant="body-small">
          We never disclose your information. By tapping on Continue, you agree
          with our
          <IonButton
            mode="ios"
            className="link"
            href={PRIVACY_LINK}
            target="_blank"
          >
            Privacy Policy
          </IonButton>{' '}
          and
          <IonButton
            mode="ios"
            className="link"
            href={TERMS_LINK}
            target="_blank"
          >
            Terms of Use
          </IonButton>
          .
        </UiTypography>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </PageStyles>
  );
};
